import {animateByClass} from "../../../Library/Animation.js";
import {updateGroupState} from "./Group.js";

document.addEventListener('click', async (event) => {
    const target = event.target.closest('.automation-filter .remove-filter');

    if (!target) {
        return;
    }

    const filter        = target.closest('.automation-filter');
    const filterGroup   = filter.closest('.filter-group');
    const configuration = filter.closest('.filter-configuration');
    const allFilters    = Array.from(configuration.querySelectorAll('.automation-filter'));
    const globalIndex   = allFilters.indexOf(filter);

    await animateByClass(filter, 'remove-filter-animation');

    const previousConnector = filter.previousElementSibling;
    const nextConnector     = filter.nextElementSibling;

    if (previousConnector?.classList.contains('filter-connector')) {
        previousConnector.remove();
    } else if (nextConnector?.classList.contains('filter-connector')) {
        nextConnector.remove();
    }

    filter.remove();

    if (filterGroup) {
        updateGroupState(filterGroup);
    }

    document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('automationfilterremoved', {
        detail: { index: globalIndex },
    }));
});
